import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const AnalyticsStepTwoStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .page-menu {
    width: 100%;
  }

  .return-button {
    border: none;
    background: rgba(135, 155, 166, 0.15);
    border-radius: 4px;
    margin-right: 10px;
    height: 28px;
    min-width: auto;
  }

  .return-button:hover {
    background: rgba(135, 155, 166, 0.2);
  }

  .charts-container {
    display: flex;
    flex-wrap: wrap;
    height: 70%;
    min-height: 600px;
    justify-content: center;
  }

  .scroll-wrapper {
    overflow: auto;
    height: calc(100% - 105px);
    display: flex;
    flex-direction: column;
  }

  .chart-wrapper {
    width: 49%;
    height: 50%;
    border: 1px solid #2e3339;
    border-radius: 6px;
    margin: 5px;
    padding: 2px;
    background-color: #1d2024;
  }

  .criteria-selection {
    padding-bottom: 12px;
    display: flex;
    align-items: center;
  }

  .periodicity-control {
    width: 320px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-left: 15px;
  }

  .control-label {
    color: var(--gray-lighter);
    font-size: 13px;
    font-weight: 700;
  }

  .auto-height {
    height: 100%;
  }

  .full-height-tab {
    height: 100%;
    padding-top: 10px;
  }

  .drilldown-grid {
    min-height: 300px;
    max-height: 365px;
    margin-top: 25px;
  }
`;
